import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import root from 'window-or-global';
import queryString from 'query-string';
import { getMessage } from '../common/message/Message';

const mapStateToProps = (state) => {
    return {
        configState: state.get('config').toJS(),
        locale: state.get('localization').get('locale'),
        messages: state.get('localization').get('messageProperties')
    };
};

@connect(mapStateToProps)
export default class LoginWrapper extends React.Component {
    static propTypes = {
        configState: PropTypes.object,
        locale: PropTypes.string,
        productName: PropTypes.string.isRequired,
        messages: PropTypes.object
    };

    getLoginParams = () => {
        const { locale, messages, productName } = this.props;
        const returnPath = root.location.href;
        const regMsg = getMessage(messages, 'epic.common.accountportal.default.register');
        const loginMsg = getMessage(messages, 'epic.common.accountportal.default.sign_in');
        return {
            lang: locale,
            regSubheading: regMsg,
            loginSubheading: loginMsg,
            redirectUrl: returnPath,
            productName,
            noHostRedirect: true
        };
    };

    render() {
        const loginParams = this.getLoginParams();
        root.location.href = `${this.props.configState.accountPortalBase}/login/customized?${queryString.stringify(loginParams)}`;
        return null;
    }
}
